import React, { Component } from "react";
import { Input, Button } from "reactstrap";

import TYDatePicker from "../../../TYDatePicker";
import Helpers from "../../../../Utils/Helpers";
import Registry from "../../../../Utils/Registry";


class ExportFormUniq extends Component {
    state = {
        dateMax: null,
        dateMin: null,
        errors: {},
        toEmails: [],
        title: ""
    };

    componentDidMount(){
        setTimeout(() => {
            let user = Registry.registered("user");
            if(user)
                this.addDest(user.email);
        }, 500);
    }
 
    setInterval = (key, value) => {
        let states = this.state;
        states[key] = value;
        this.setState(states);
    };

    updateDest = (index, email) => {
        let e = this.state.toEmails;
        if(index < e.length){
            e[index] = email;
            this.setState({toEmails: e});
        }
    }

    addDest = (destEmail="") => {
        let e = this.state.toEmails;
        e.push(destEmail);
        this.setState({toEmails: e});
    }

    removeDest = index => {
        let e = this.state.toEmails.slice();
        e.splice(index, 1);
        this.setState({toEmails: e});
    };

    exportData = () => {
        const { 
            dateMin, 
            dateMax, 
            toEmails, 
            title 
        } = this.state;

        this.setState({errors: {}});
        const toEmailsFiltered = toEmails.filter(email => email.length > 0);
        const diff = (dateMax && dateMin) ? dateMax.getTime() - dateMin.getTime() : 0;
        
        if(dateMin && dateMax && diff > 0){
            this.props.onSubmit(
                Helpers.formatDate(dateMin, 'YYYY-MM-DD'), 
                Helpers.formatDate(dateMax, 'YYYY-MM-DD'),
                toEmailsFiltered, title
            );
        }
        else{
            // Handle missing data
            let errors = {};

            if(!title)
                errors.title = "Il nous faut un nom pour votre export";
            if(!toEmailsFiltered.length)
                errors.toEmails = "Nous n'avons personne avec qui partager cet export";

            if(!dateMin)
                errors.dateMin = "Vous devez renseigner une date de depart pour l'extraction des données";

            if(!dateMax)
                errors.dateMax = "Vous devez renseigner une date de fin pour l'extraction des données";
            else if(dateMin && dateMax && diff <= 0)
                errors.dateMax = "La date de fin doit etre posterieure à la date de départ";

            this.setState({errors});
        }
    };

    render(){
        const { 
            errors, 
            toEmails, 
            title
        } = this.state;

        return <div>
            <div className="bold">Interval *</div>
            <br />
            
            <div className="wrap-between-sm-md">
                { errors.dateMin && <p className="red">{errors.dateMin}</p> }
                <TYDatePicker 
                    className="ty-calendar-wp-100" 
                    inputClassName={errors.dateMin ? 'error' : ''} 
                    onDatePicked={date => { 
                        this.setState({dateMin: date}); 
                    }} 
                />
                <div className="flex-centered pad-10">au</div>
                { errors.dateMax && <p className="red">{errors.dateMax}</p> }
                <TYDatePicker
                    className="ty-calendar-wp-100"
                    inputClassName={errors.dateMax ? 'error' : ''} 
                    onDatePicked={date => { 
                        this.setState({dateMax: date}); 
                    }}
                />
            </div>
            <br />

            { /* Email dest */ }
            <div className="bold">Destinataires *</div>
            <br />
            <div className="wrap-between-sm-md">
                { errors.toEmails && <p className="red">{errors.toEmails}</p> }
                {
                    toEmails.map((email, i) => {
                        return <div className="d-flex align-items-center marg-b-10" key={`dest-extract-${i}-${this.id}`}>
                            <Input
                                placeholder="Email ..."
                                type="text"
                                className={errors.toEmails ? 'error' : ''}
                                value={email}
                                onChange={e => { this.updateDest(i, e.target.value)} }
                            />
                        </div>;
                    })
                }

                <div className="pointer underline-hover" onClick={_ => { this.addDest(); }}>
                    <i className="icon icon-plus marg-r-5"></i> 
                    Ajouter un destinataire
                </div>
            </div>
            <br />

            { /* Title block */ }
            <div className="bold">Titre *</div>
            <br />
            <div>
                { errors.title && <p className="red">{errors.title}</p> }
                <Input 
                    placeholder="Titre de l'export ..." 
                    value={title} 
                    className={errors.title ? 'error' : ''}
                    onChange={e => { this.setState({title: e.target.value}); }} 
                />
            </div>
            <br />

            <div className="center marg-t-20">
                <Button className="text-uppercase" color="primary" onClick={this.exportData}>
                    {
                        this.props.loading ?
                            <i className="icon icon-loading animated spin infinite f-18"> </i>
                            : "Exporter"
                    }
                </Button>
            </div>
        </div>;
    }
}


ExportFormUniq.defaultProps = {
    onSubmit: (dateMin, dateMax, dests, title) => {},
    loading: false
};


export default ExportFormUniq;


// WEBPACK FOOTER //
// ./src/components/Operations/Export/Forms/Uniq.js